import styled from 'styled-components';

export const RowView = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    padding-left: 40px;
    padding-right: 22px;
    margin-top: 20px;
`;

export const ContentView = styled.div`
    width: 100%;
    border-radius: 4px;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 8px;
    
    @media (max-width: 768px) {
        padding-left: 20px;
        padding-right: 20px;
    }
    
    @media (max-width: 480px) {
        padding-left: 15px;
        padding-right: 15px;
    }
`;

export const Touchable = styled.div`
    cursor: pointer;
    width: 100%;
`;

export const ColumnView = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LabelContainerNew = styled.div<{
    flexDirection: 'row' | 'column';
}>`
    display: flex;
    flex-direction: ${(props) =>
        props.flexDirection}; // Dynamic row or column direction
    justify-content: flex-start; // Align items to the start of the row
    align-items: center; // Vertically center the items
    flex-wrap: nowrap; // Prevent wrapping to the next line
    gap: 10px; // Optional: space between items
    width: 100%;
    height: auto;
    overflow-x: auto; // Enable horizontal scrolling if items overflow
    padding: 10px; // Optional: Adds padding to the container
`;

export const Label = styled.div`
    text-align: center;
    flex-direction: column;
    flex: 1;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    width: 100%;
    padding-bottom: 20px;
`;

// New Gallery Components
export const GalleryContainer = styled.div`
    position: relative;
    width: 100%;
    height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 768px) {
        height: 500px;
    }
    
    @media (max-width: 480px) {
        height: 400px;
    }
`;

export const CarouselContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CarouselItem = styled.div<{
    isActive: boolean;
    isLeft: boolean;
    isRight: boolean;
}>`
    position: absolute;
    width: ${props => props.isActive ? '80%' : '60%'};
    height: ${props => props.isActive ? '90%' : '70%'};
    transform: ${props => {
        if (props.isActive) return 'translateX(0) scale(1)';
        if (props.isLeft) return 'translateX(-120%) scale(0.8)';
        if (props.isRight) return 'translateX(120%) scale(0.8)';
        return 'translateX(0) scale(0.6)';
    }};
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    z-index: ${props => props.isActive ? 3 : props.isLeft || props.isRight ? 2 : 1};
    opacity: ${props => props.isActive ? 1 : props.isLeft || props.isRight ? 0.7 : 0.3};
    
    &:hover {
        transform: ${props => {
            if (props.isActive) return 'translateX(0) scale(1.02)';
            if (props.isLeft) return 'translateX(-110%) scale(0.85)';
            if (props.isRight) return 'translateX(110%) scale(0.85)';
            return 'translateX(0) scale(0.65)';
        }};
        opacity: ${props => props.isActive ? 1 : 0.8};
    }
`;

export const NavigationButton = styled.button<{
    position: 'left' | 'right';
}>`
    position: absolute;
    ${props => props.position}: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.9);
    color: #333;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    
    &:hover {
        background: rgba(255, 255, 255, 1);
        transform: translateY(-50%) scale(1.1);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }
    
    &:active {
        transform: translateY(-50%) scale(0.95);
    }
    
    @media (max-width: 768px) {
        width: 45px;
        height: 45px;
        font-size: 20px;
        ${props => props.position}: 15px;
    }
    
    @media (max-width: 480px) {
        width: 40px;
        height: 40px;
        font-size: 18px;
        ${props => props.position}: 10px;
    }
`;

export const DocumentCard = styled.div<{
    isActive: boolean;
}>`
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: ${props => props.isActive 
        ? '0 20px 40px rgba(0, 0, 0, 0.15)' 
        : '0 8px 24px rgba(0, 0, 0, 0.1)'
    };
    overflow: hidden;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
`;

export const DocumentContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
    gap: 15px;
    
    @media (max-width: 768px) {
        padding: 15px;
        gap: 12px;
    }
    
    @media (max-width: 480px) {
        padding: 12px;
        gap: 10px;
    }
`;

export const ZoomedView = styled.div<{
    isActive: boolean;
}>`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: ${props => props.isActive ? 'scale(1)' : 'scale(0.9)'};
    transition: transform 0.3s ease;
    
    & > div {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }
`;

export const DocumentInfo = styled.div<{
    isActive: boolean;
}>`
    text-align: center;
    padding: 10px;
    background: ${props => props.isActive ? '#f8f9fa' : '#f1f3f4'};
    border-radius: 8px;
    transition: all 0.3s ease;
    
    & > * {
        margin: 5px 0;
    }
`;

export const SidePanel = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    width: 200px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    z-index: 5;
`;

// Responsive layout components for mobile
export const ResponsiveContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    gap: 12px;
    min-height: 300px;
    
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 8px;
    }
`;

export const PDFContainer = styled.div<{ isActive: boolean }>`
    flex: 0 0 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: ${props => props.isActive ? 'scale(1)' : 'scale(0.9)'};
    transition: transform 0.3s ease;
    background: #ffffff;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 768px) {
        flex: 0 0 40%;
        order: 1;
        min-height: 120px;
    }
`;

export const PDBContainer = styled.div`
    flex: 0 0 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 768px) {
        flex: 0 0 60%;
        order: 2;
        min-height: 180px;
    }
`;

export const MainContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    height: 600px;
    margin-bottom: 20px;
    
    @media (max-width: 768px) {
        flex-direction: column;
        height: auto;
    }
`;

export const CarouselWrapper = styled.div`
    position: relative;
    flex: 1;
    width: auto;
    height: 100%;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 768px) {
        flex: 0 0 auto;
        width: 100%;
        height: 500px;
        min-height: 500px;
    }
`;

export const AIDialogWrapper = styled.div`
    flex: 0 0 350px;
    width: 350px;
    height: 100%;
    
    @media (max-width: 768px) {
        flex: 0 0 auto;
        width: 100%;
        height: auto;
        min-height: 400px;
    }
`;

export const BackButton = styled.button`
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.2);
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        background: rgba(255, 255, 255, 0.3);
        border-color: rgba(255, 255, 255, 0.5);
    }
    
    @media (max-width: 768px) {
        position: static;
        transform: none;
        margin-bottom: 15px;
        align-self: flex-start;
        background: rgba(255, 255, 255, 0.15);
        border-color: rgba(255, 255, 255, 0.25);
        padding: 8px 16px;
        font-size: 13px;
    }
`;

export const HeaderTitle = styled.h2`
    margin: 0;
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    width: 100%;
    
    /* Responsive font sizing */
    @media (min-width: 1200px) {
        font-size: 32px;
    }
    
    @media (min-width: 768px) and (max-width: 1199px) {
        font-size: 28px;
    }
    
    @media (min-width: 480px) and (max-width: 767px) {
        font-size: 24px;
    }
    
    @media (max-width: 479px) {
        font-size: 20px;
    }
    
    /* Ensure text doesn't overflow on very narrow screens */
    @media (max-width: 400px) {
        font-size: 18px;
        word-wrap: break-word;
        hyphens: auto;
    }
`;

export const HeaderDescription = styled.p`
    margin: 10px 0 0 0;
    opacity: 0.9;
    text-align: center;
    width: 100%;
    max-width: 800px;
    
    /* Responsive font sizing */
    @media (min-width: 1200px) {
        font-size: 16px;
    }
    
    @media (min-width: 768px) and (max-width: 1199px) {
        font-size: 15px;
    }
    
    @media (min-width: 480px) and (max-width: 767px) {
        font-size: 14px;
    }
    
    @media (max-width: 479px) {
        font-size: 13px;
    }
    
    /* Ensure text doesn't overflow on very narrow screens */
    @media (max-width: 400px) {
        font-size: 12px;
        word-wrap: break-word;
        hyphens: auto;
    }
`;

export const GalleryHeader = styled.div`
    text-align: center;
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    color: white;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    
    /* Responsive layout to prevent overlap */
    @media (min-width: 1200px) {
        padding: 30px;
        gap: 20px;
    }
    
    @media (min-width: 768px) and (max-width: 1199px) {
        padding: 25px;
        gap: 18px;
    }
    
    @media (min-width: 480px) and (max-width: 767px) {
        padding: 20px;
        gap: 15px;
    }
    
    @media (max-width: 479px) {
        padding: 15px;
        gap: 12px;
    }
    
    /* Ensure back button and title don't overlap */
    @media (max-width: 600px) {
        text-align: center;
        
        /* Stack elements vertically on narrow screens */
        > * {
            width: 100%;
            max-width: 100%;
        }
    }
`;
